module.exports = __webpack_public_path__ + "static/media/falcon.d1903852.jpg";